export default (Vue, options = {
  authorisations: currentUser => {},
  currentUser: store => store.getters['currentUser']
}) => {
  Vue.mixin({
    beforeCreate () {
      const { currentUser, authorisations } = options

      this.$can = (action, entity) => authorisations(currentUser(this.$store))[entity][action]
      this.$cannot = (action, entity) => !this.$can(action, entity)
    }
  })
}



// WEBPACK FOOTER //
// ./src/plugins/authorisations.js